import { AuthenticationFlowType } from './enums';
import { IAuthenticationFlowRunner, IAuthenticationFlowFactory } from './models';
import { LoaderManager } from '../../loaders/LoaderManager';

export class AuthenticationFlowFactory implements IAuthenticationFlowFactory {
    private get _crossAuthenticationFlowRunnerPromise(): Promise<IAuthenticationFlowRunner> {
        return LoaderManager.Instance.CrossAuthenticationFlowRunnerLoader.Instance;
    }

    private get _regularAuthenticationFlowRunnerPromise(): Promise<IAuthenticationFlowRunner> {
        return LoaderManager.Instance.RegularAuthenticationFlowRunnerLoader.Instance;
    }

    private get _biometricsAuthenticationFlowRunnerPromise(): Promise<IAuthenticationFlowRunner> {
        return LoaderManager.Instance.BiometricsAuthenticationFlowRunnerLoader.Instance;
    }

    constructor() {}
    public async create(flowType: AuthenticationFlowType): Promise<IAuthenticationFlowRunner> {
        let authenticationFlowRunner: IAuthenticationFlowRunner;

        switch (flowType) {
            case AuthenticationFlowType.Regular: {
                authenticationFlowRunner = await this._regularAuthenticationFlowRunnerPromise;
                break;
            }
            case AuthenticationFlowType.Cross: {
                authenticationFlowRunner = await this._crossAuthenticationFlowRunnerPromise;
                break;
            }
            case AuthenticationFlowType.Biometrics: {
                authenticationFlowRunner = await this._biometricsAuthenticationFlowRunnerPromise;
                break;
            }
        }

        return authenticationFlowRunner;
    }
}
